'use client';
import { useCustomerProfile } from 'components/base/account/customerProfile';
import { MaterialIcon } from 'components/modulab/MaterialIcon';
import { useClient } from 'hooks/useClient';
import { JSX } from 'react';
import { localeSpecificGroup } from 'utils/override';
import {
  accountButtonHoverEvent,
  track,
  trackingAuthButtonClick,
} from 'utils/tracking';
import { useClientContext } from '$/modules/context/client';

type AccountButtonProps = {
  tracking?: { location: string };
  loggedInUrl: string;
  postLoginRedirectUrl?: string;
};

const STATIC_TEXT = localeSpecificGroup({
  logIn: {
    _: 'Log in',
    zh: '登入',
  },
  logOut: {
    _: 'Log out',
    zh: '登出',
  },
});

export function AccountButton(props: AccountButtonProps): JSX.Element {
  const { lang, langPrefix } = useClientContext();
  const profile = useCustomerProfile();
  const loggedIn = profile.current?.loggedIn;
  const staticText = STATIC_TEXT.get(lang);

  const href = useClient(() => location.href);

  const onMouseEnter = () => {
    track(accountButtonHoverEvent(props.tracking?.location));
  };

  let target;
  if (loggedIn) {
    target = props.loggedInUrl
      ? `${langPrefix}${props.loggedInUrl}`
      : undefined;
  } else {
    target =
      href != null
        ? `${langPrefix}/login?redirect_uri=${encodeURIComponent(
            props.postLoginRedirectUrl || href,
          )}`
        : `${langPrefix}/login`;
  }

  return (
    <div className="flex items-center gap-4">
      {loggedIn ? (
        <button
          type="button"
          className="flex size-9 flex-none items-center justify-center rounded-full bg-primary-800"
          onClick={() => {
            trackingAuthButtonClick(
              'Login CTA/Logout CTA',
              '',
              'Top Nav_Login/Logout',
            );
            window.location.href = `${window.location.origin}${langPrefix}/user/account`;
          }}
        >
          <MaterialIcon icon="account_circle" />
        </button>
      ) : (
        <>
          <a
            href={target}
            onMouseEnter={onMouseEnter}
            onClick={() =>
              trackingAuthButtonClick(
                'Login CTA/Logout CTA',
                '',
                'Top Nav_Login/Logout',
              )
            }
            className="w-max flex-none font-semibold text-primary-800 text-base lg:text-lg"
          >
            {staticText.logIn}
          </a>
          <a
            href={target}
            onMouseEnter={onMouseEnter}
            onClick={() =>
              trackingAuthButtonClick(
                'Login CTA/Logout CTA',
                '',
                'Top Nav_Login/Logout',
              )
            }
            className="flex size-9 flex-none items-center justify-center rounded-full bg-primary-800"
          >
            <MaterialIcon icon="account_circle" />
          </a>
        </>
      )}
    </div>
  );
}
